<template>
  <div id="map_project">
    <ZipcodeStructure />
  </div>
</template>

<script>
import ZipcodeStructure from "./components/ZipcodeStructure.vue";

export default {
  name: "MapProject",
  components: {
    ZipcodeStructure
  }
};
</script>
